import React, { FC, useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../../config/environmentConfig';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { v4 as uuidv4 } from 'uuid';

const AnalyticsPage: FC = () => {
    const [url, setUrl] = useState('');
    const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);

    useEffect(() => {
        const fetchUrl = async (): Promise<void> => {
            try {
                let browserSessionId = sessionStorage.getItem('browserSessionId');

                if (!browserSessionId) {
                    browserSessionId = uuidv4();
                    sessionStorage.setItem('browserSessionId', browserSessionId);
                }

                if (checkRoles(authUser, CLAIMS.SUPER_ADMIN)) {
                    const response = await axios.get(`${BASE_URL.MERCHANTS}/Analytics/admin/analytics?browserSessionId=${browserSessionId}`);
                    setUrl(response.data.dashboardUrl);
                } else if (checkRoles(authUser, CLAIMS.PARTNER_ADMIN)) {
                    const response = await axios.get(`${BASE_URL.MERCHANTS}/Analytics/partner/analytics?browserSessionId=${browserSessionId}`);
                    setUrl(response.data.dashboardUrl);
                }

            } catch (error) {
                console.error('Failed to fetch URL', error);
            }
        };

        fetchUrl();
    }, []);

    if (!url) {
        return null;
    }

    return (
        // <div style={{ width: 'calc(100vw - SIDEBAR_WIDTH)', height: 'calc(100vh - HEADER_HEIGHT)' }}>
        <div style={{ width: '100%', height: '100%' }}>
            {url && <iframe src={url} title="Analytics" style={{ width: '100%', height: '100%' }} rel="noopener noreferrer" />}
        </div>
    );
};

export default AnalyticsPage;
